import React  from 'react';
import styles from './questionAnswers.css';
import { Scrollbars } from 'react-custom-scrollbars';

/**
 *
 * @type {React.NamedExoticComponent<{readonly setEventSound?: *, readonly answers?: *, readonly handleAnswerSelection?: *, readonly question?: *}>}
 */
const QuestionAnswers = React.memo( ( { setEventSound, question, answers, handleAnswerSelection } ) => {
    const setSound = () => setEventSound( { events: 'hover' } );
    const { localization } = question;

    return (
        <Scrollbars
            className={ styles.scroll }
            autoHideTimeout={ 1000 }
            autoHideDuration={ 200 }
            thumbMinSize={ 30 }
            universal={ true }
            renderTrackHorizontal={ props => <div { ...props } className={ styles.trackHorizontal }/> }
            renderTrackVertical={ props => <div { ...props } className={ styles.trackVertical }/> }
            renderThumbHorizontal={ props => <div { ...props } className={ styles.thumbHorizontal }/> }
            renderThumbVertical={ props => <div { ...props } className={ styles.thumbVertical }/> }
            renderView={ props => <div { ...props } style={ {
                marginBottom: '-20px',
                position: 'absolute',
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px',
                overflow: 'auto',
            } }/> }>
            <div className={ styles.itemListWrap }>
                <div className={ styles.wrapper }>
                    { answers.map( ( answer, i ) => {
                            let type = 'default';
                            const printStr =( answer.option_text && answer.option_text.length > 15 ) ? answer.option_text.substr( 0, 15 ) + '...' : answer.option_text;

                            if ( Boolean( answer.is_option_text_active ) === true && answer.option_text == null || answer.option_text == '' ) {
                                type = 'default';
                            } else if ( Boolean( answer.is_option_text_active ) === true && answer.option_text != null || answer.option_text == '' ) {
                                type = 'custom';
                            } else {
                                type = 'none';
                            }

                            return (
                                <div className={ styles.answerWrapper } key={ answer.id }>
                                    <div
                                        onMouseEnter={ setSound }
                                        className={ styles.answerBlock }
                                        style={ {
                                            height: answer.is_option_text_active ? '100%' : '100%',
                                            background: `url(${ answer.image.url }) #000 center center no-repeat`
                                        } }
                                        aria-label={ answer.image.description || 'Quiz image' }
                                        onClick={ () => handleAnswerSelection( {
                                            question_localization_id: localization.id,
                                            id: answer.id,
                                            user_answer: answer.id,
                                            type: localization.answer_model
                                        } ) }
                                    >
                                        { answer.is_option_text_active ? <div className={ styles.footer }> { ( type === 'default' ) ? `Option ${ i + 1 }` : `${ printStr }` }</div> : null }
                                    </div>
                                </div>
                            );
                        }
                    ) }
                </div>
            </div>
        </Scrollbars>
    );

} );

export default QuestionAnswers;


